import {FC} from 'react'

export const MONTH_KEYS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec'
] as const
export const MONTH_COUNT = 12
export const TOOLTIP_BG = '#1F262E'
export const BASIC_ADVANCED_LINE_COLOR = '#EE8B00'
export const ADVANCED_EXCELLENCE_LINE_COLOR = '#00AB50'
export const ZONE_LABEL_COLOR = '#54708C'
export const GRID_LINE_COLOR = '#EAEDF0'
export const GRID_LINE_COUNT = 30
export const DATA_POINT_CHART_HEIGHT_PX = '400'
export const SERIES_COLORS = ['#8F26E0', '#009D93', '#CB2BBC', '#98C31C', '#EE6400']
export const SERIES_BG_COLORS = ['#F9F4FD', '#F2FAFA', '#FCF4FC', '#FAFCF4', '#FEF7F2']
export const SERIES_BORDER_COLORS = ['#EEDEFA', '#D9F0EF', '#F7DFF5', '#F0F6DD', '#FCE8D9']

/** Returns a stable color index 0-4 for a given id, independent of array position */
export const getStableColorIndex = (id: string): number => {
  let hash = 5381
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) + hash) ^ id.charCodeAt(i)
  }
  return Math.abs(hash) % SERIES_COLORS.length
}
